<template>
	<v-card :id="'availability-' + index + '-[' + availability.availability_code + ']'" class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-list-item-title class="subtitle-2 font-weight-bold"
					>{{ dateFormattedMomentjs(availability.date) }} - {{ dateFormattedMomentjs(availability.end_date) }}</v-list-item-title
				>
				<v-list-item-subtitle class="blue--text lighten-1 font-weight-bold">{{ availability.start_time }} - {{ availability.end_time }}</v-list-item-subtitle>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="locumViewAvailability(availability)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';

export default {
	name: 'LocumAvailabilityCard',
	components: {},
	props: {
		index: { type: Number, required: true },
		availability: { type: Object, required: true },
	},
	data: () => ({}),
	computed: {
		computedstartDateFormattedMomentjs() {
			return this.availability.date ? moment(this.availability.date).format('MMM Do YYYY') : '';
		},
		// eslint-disable-next-line
		computedendDateFormattedMomentjs() {
			return this.availability.end_date ? moment(this.availability.end_date).format('MMM Do YYYY') : '';
		},
	},

	watch: {},
	created() {},
	mounted() {},
	beforeDestroy() {},

	methods: {
		locumViewAvailability(availability) {
			const { available_dates, start_time, end_time, id: availabilityId, availability_code, status } = availability;

			const booking = { start_time, end_time, booking_dates: available_dates, id: availabilityId, availability_code, status };
			store.dispatch('setLocumViewingPractice', { booking, source: 'viewLocumAvailability' });
			bus.$emit('change-context', 'view-practice-details-card');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},
	},
};
</script>
